import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {
    getSelectedCustomer
} from '@store/selectors/user.selector';
import {ConfigState} from '@store/state/config.state';
import {ShoppingCartState} from '@store/state/shopping-cart';
import {Observable, Subject, combineLatest} from 'rxjs';
import {NumberFormat} from '@iw-shop/core/functions/number-format';
import {DeliveryTourService} from "@iw-shop/delivery-tour/services/delivery-tour.service";
import { take, takeUntil} from "rxjs/operators";
import {ApiDeliveryTour} from "@api/delivery-tours";

@Component({
    selector: 'iw-shop-delivery-tour-minimum-order-values',
    standalone: false,
    templateUrl: './delivery-tour-minimum-order-values.component.html',
    styleUrls: ['./delivery-tour-minimum-order-values.component.scss']
})
export class DeliveryTourMinimumOrderValuesComponent implements OnInit, OnDestroy {

    destroy$: Subject<boolean> = new Subject<boolean>();
    config$: Observable<ConfigState>;
    shoppingCart$: Observable<ShoppingCartState>;

    deliveryTour?: ApiDeliveryTour;

    shoppingCartMerchandiseValue: number = 0;
    shoppingCartArticles: number = 0;
    minimumMerchandiseValue: number = 0;
    minimumArticles: number = 0;
    priceMode: 'net' | 'gross' = 'gross';

    constructor(private store: Store<AppState>, private deliveryTourService: DeliveryTourService) {
        this.config$ = this.store.select(state => state.config);
        this.shoppingCart$ = this.store.select(state => state.shoppingCart);
    }

    ngOnInit() {
        combineLatest([this.deliveryTourService.getSelectedDeliveryTour(), this.store.select(state => state.shoppingCart)])
            .pipe(
                takeUntil(this.destroy$)
            ).subscribe(
            {
                next: ([deliveryTour, shoppingCart]) => {
                    if(deliveryTour){
                        this.deliveryTour = deliveryTour;
                    }
                    this.loadConditions();
                }
            }
        );
    }

    loadConditions(){
        const deliveryTour = this.deliveryTourService.getSelectedDeliveryTour().value;
        // reset
        this.shoppingCartMerchandiseValue = 0;
        this.shoppingCartArticles = 0;
        this.minimumMerchandiseValue = 0;
        this.minimumArticles= 0;
        if(deliveryTour){
            this.shoppingCartArticles = this.deliveryTourService.getShoppingCartArticles(deliveryTour.minimumArticles?.excludedGroups ?? [], deliveryTour.minimumArticles?.requiredArticleUnitTypes ?? []);
            this.store.select(getSelectedCustomer).pipe(take(1)).subscribe(
                r => {
                    if (r?.priceMode &&
                        r.priceMode == 'net') {
                        this.priceMode = r.priceMode;
                        this.minimumMerchandiseValue = deliveryTour.minimumMerchandiseValue?.net ?? 0;
                        this.shoppingCartMerchandiseValue = this.deliveryTourService.getShoppingCartMerchandiseValue('net', deliveryTour.minimumMerchandiseValue?.excludedGroups);
                    } else {
                        this.minimumMerchandiseValue = deliveryTour.minimumMerchandiseValue?.gross ?? 0;
                        this.shoppingCartMerchandiseValue = this.deliveryTourService.getShoppingCartMerchandiseValue('gross', deliveryTour.minimumMerchandiseValue?.excludedGroups);
                    }
                    this.minimumArticles =  deliveryTour.minimumArticles?.value ?? 0;
                }
            )
        }
    }

    isOrderAvailable(){
        if(this.deliveryTourService.getSelectedDeliveryTour().value?.disableOrderIfConditionsFailed){
            if(this.minimumArticles > this.shoppingCartArticles ||
                this.minimumMerchandiseValue > this.shoppingCartMerchandiseValue){
                return false;
            }
        }
        return true;
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    protected readonly MathRound = Math.round;
    protected readonly NumberFormat = NumberFormat;


}
